import { Directive, EventEmitter, Output, HostListener, ElementRef } from '@angular/core';

export interface InputChangeEvent {
  value: string;
  dayChange: boolean;
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[cfDatepickerInput]'
})
export class DatepickerInputDirective {
  /**
   * Input value change is used to emit an event
   * when the user changes the input value
   */
  @Output() inputValueChange = new EventEmitter<string>();

  /**
   * Calendar value change is used to emit an event
   * when the input is updated due to the calendar
   * value changing
   */
  @Output() calendarValueChange = new EventEmitter<InputChangeEvent>();

  @HostListener('input', ['$event']) onInput(event) {
    this.inputValueChange.emit(event.target.value);
  }

  @HostListener('click', ['$event']) onFocus(event) {
    const value = event.target.value;

    // if user is selecting a range of values (like select all to clear the field)
    // we don't want to move the cursor.
    if (event.target.selectionStart === event.target.selectionEnd) {
      this.setCursorPosition(this.element.nativeElement, value, event.target.selectionEnd);
    }
  }

  // element is public so that the calendar can access
  // the input value and display the correct date.
  constructor(public element: ElementRef) {}

  /**
   * Called when calendar sets the value of input
   */
  setValue({ value, dayChange}) {
    this.element.nativeElement.value = value;
    this.calendarValueChange.emit({
      value,
      dayChange
    });
  }

  /**
   * Move the cursor to correct position
   */
  private setCursorPosition(elem, value, selection) {
    let cursorPos;
    value = value.replace(/_+/g, '');

    // only set caret position if user is attempting
    // to place cursor on the underscores
    if (selection < value.length) {
      return;
    }

    cursorPos = value.length;

    // account for the '/' in date
    if (value.length > 4 && value.length < 6) {
      cursorPos = cursorPos - 1;
    } else if (value.length <= 4) {
      cursorPos = cursorPos - 2;
    }

    // set the caret position
    if (elem.setSelectionRange) {
      elem.focus();
      setTimeout(() => {
        elem.setSelectionRange(cursorPos, cursorPos);
      }, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker-input/datepicker-input.directive.ts